import { call, select } from 'redux-saga/effects';
import { getMyDataType as getMyDataTypePromise } from '@bitComponents/adabyron/client';

const contextStore = state => state.context.data;

export function* getMyDataType() {
  try {
    const context = yield select(contextStore);
    const response = yield call(getMyDataTypePromise, context);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
